import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Fax Settings'
      breadcrumbs={[
        {
          label: 'Phone',
        },
        {
          label: 'Fax Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/phone/fax-settings',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
